export default __webpack_public_path__ + "static/media/abbeville6.8727a218.jpg";